import React, { FC, useEffect, useState } from 'react'
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js"
import { OnApproveData } from "@paypal/paypal-js/types/components/buttons"
import axios, { AxiosResponse } from 'axios'
import styled from 'styled-components'

import { FlexRow } from '../../../FlexboxReusables/FlexItems'
import { BuyWithPaypalStepProps, ConfirmPaymentRequest, ConfirmedPaymentResonse } from '../types'
import { apiUrl } from '../../../../globals'
import { notification } from 'antd'
import LoadingSpinner from '../../../LoadingSpinner'

export const BuyWithPaypalStep: FC<BuyWithPaypalStepProps> = ({
  course,
  isPartner,
  partnerName,
  buyersDetails,
  invoiceCurrency,
  numberOfParticipants,
  setPaymentDone,
  setSuccessfulPaymentResponse,
  goToNextStep
}) => {
  const [ loading, setLoading ] = useState<boolean>(true)
  const [ paypalClientId, setPaypalClientId ] = useState<string | undefined>(undefined)

  useEffect(() => {
    getPaypalClientId()
  }, [])

  const getPaypalClientId = async () => {
    const res = await axios.get(`${apiUrl}/paypal/get-client-id`)

    setLoading(false)
    setPaypalClientId(res.data)  
  }

  const createOrder = async () => {
    if (!course.purchasePrice) {
      notification.error({
        message: 'Fehler', // TODO: i18n
        description: 'Dieser Kurs kann nicht gekauft werden, da er keinen Preis hat',
        placement: 'bottomRight'
      })

      return
    }

    const response = await axios.post(`${apiUrl}/paypal/create-order`, {
      items: [
        {
          id: course.id,
          quantity: numberOfParticipants
        }
      ],
      isPartner,
      partnerName
    })

    if (!response.data.orderId) {
      notification.error({
        message: 'Fehler', // TODO: i18n
        description: 'Es ist ein Fehler beim Erstellen der Bestellung aufgetreten',
        placement: 'bottomRight'
      })

      return
    }

    return response.data.orderId
  }

  const onApprove = async (data: OnApproveData) => {
    const confirmPaymentRequest: ConfirmPaymentRequest = {
      ...data,
      orderId: data.orderID,
      courseId: course.id,
      paidParticipantsCount: numberOfParticipants,
      ...buyersDetails,
      targetCurrency: invoiceCurrency,
      isPartner
    }

    const response: AxiosResponse<ConfirmedPaymentResonse> = await axios.post(
      `${apiUrl}/paypal/confirm-payment`,
      confirmPaymentRequest
    )

    setSuccessfulPaymentResponse({
      courseAccessId: response.data.courseAccessId,
      courseId: response.data.courseId,
      linkForParticipants: response.data.linkForParticipants,
      linkForStatistics: response.data.linkForStatistics,
      paidParticipantsCount: response.data.paidParticipantsCount,
      examTakenCount: response.data.examTakenCount,
      currentInvoiceNumber: response.data.currentInvoiceNumber
    })
    setPaymentDone(true)
    goToNextStep()
  }

  if (loading) {
    return (
      <FlexRow margin='2em 0' height='500px'>
        <LoadingSpinner loadingText='Lade Paypal...' />
      </FlexRow>
    )
  }

  return (
    <FlexRow margin='2em 0'>
      <PayPalScriptProvider options={{ clientId: paypalClientId || '', currency: "EUR" }}>
        <PaypalCssDiv>
          <PayPalButtons
            createOrder={createOrder}
            onApprove={onApprove}
            style={{ layout: "vertical", shape: 'rect', height: 55 }}
          />
        </PaypalCssDiv>
      </PayPalScriptProvider>
    </FlexRow>
  )
}

export default BuyWithPaypalStep

// Paypal doesn't like inline styles except for very specific ones, hence the workaround
const PaypalCssDiv = styled.div`
  .paypal-buttons {
    width: 500px !important;
  }
`